/** Build-time public client env. Secrets never belong here. */

export const IS_PROD = import.meta.env.PROD;

export const API_BASE_URL = (
  (import.meta.env.VITE_API_URL as string | undefined) ||
  (IS_PROD ? '/api' : 'http://localhost:2000/api')
).replace(/\/$/, '');

export const SOCKET_URL =
  (import.meta.env.VITE_SOCKET_URL as string | undefined) ||
  (IS_PROD ? 'https://tripnovac-hub-production.up.railway.app' : '');

/** Public Turnstile site key, baked at Netlify build from VITE_TURNSTILE_SITE_KEY. */
export const TURNSTILE_SITE_KEY = String(import.meta.env.VITE_TURNSTILE_SITE_KEY || '').trim();

/** Production: widget + require token whenever a site key is baked. */
export const TURNSTILE_ENFORCE =
  import.meta.env.VITE_TURNSTILE_ENFORCE === 'true' ||
  (IS_PROD && Boolean(TURNSTILE_SITE_KEY));
